import { render } from "./HeroiconsOutlineCloudUpload.vue?vue&type=template&id=10f6a71e"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCloudUpload.vue"]])

export default __exports__